// @ts-check
import { defineStore } from "pinia";

export const useOrderStore = defineStore("order", {
  state: () => ({
    item: {},
    optimize: {},
    options: {},
    loading: false,
    cubby: {},
    verification: {},
  }),
});
